export default [
  { label: 'Agriculture & Food Production', value: 'agriculture_and_food_production' },
  { label: 'Apparel & Accessories', value: 'apparel_and_accessories' },
  { label: 'Arts & Culture', value: 'arts_and_culture' },
  { label: 'Automotive', value: 'automotive' },
  { label: 'Baby', value: 'baby' },
  { label: 'Books & Music', value: 'books_and_music' },
  { label: 'Business Supplies & Equipment', value: 'business_supplies_and_equipment' },
  { label: 'Construction & Engineering', value: 'construction_and_engineering' },
  { label: 'Consulting & Professional Services', value: 'consulting_and_professional_services' },
  { label: 'Consumer Electronics', value: 'consumer_electronics' },
  { label: 'Dating & Personal Services', value: 'dating_and_personal_services' },
  { label: 'eLearning & Online Courses', value: 'elearning_and_online_courses' },
  { label: 'Energy & Utilities', value: 'energy_and_utilities' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Events & Venues', value: 'events_and_venues' },
  { label: 'Financial Services', value: 'financial_services' },
  { label: 'Food & Beverage', value: 'food_and_beverage' },
  { label: 'Gaming & Apps', value: 'gaming_and_apps' },
  { label: 'Health & Beauty', value: 'health_and_beauty' },
  { label: 'Health & Wellness', value: 'health_and_wellness' },
  { label: 'Home & Garden', value: 'home_and_garden' },
  { label: 'Hotels & Accommodation', value: 'hotels_and_accommodation' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'Internet & eCommerce', value: 'internet_and_ecommerce' },
  { label: 'Investment & Wealth Management', value: 'investment_and_wealth_management' },
  { label: 'Legal Services', value: 'legal_services' },
  { label: 'Lifestyle & Boutique', value: 'lifestyle_and_boutique' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Marketing & Advertising', value: 'marketing_and_advertising' },
  { label: 'Media & Publishing', value: 'media_and_publishing' },
  { label: 'Medical Devices & Equipment', value: 'medical_devices_and_equipment' },
  { label: 'Nonprofit & Philanthropy', value: 'nonprofit_and_philanthropy' },
  { label: 'Other', value: 'other' },
  { label: 'Pets & Animals', value: 'pets_and_animals' },
  { label: 'Pharmaceuticals & Biotech', value: 'pharmaceuticals_and_biotech' },
  { label: 'Professional Training & Coaching', value: 'professional_training_and_coaching' },
  { label: 'Senior Care', value: 'senior_care' },
  { label: 'Software & SaaS', value: 'software_and_saas' },
  { label: 'Sports & Outdoors', value: 'sports_and_outdoors' },
  { label: 'Telecommunications', value: 'telecommunications' },
  { label: 'Toys, Art & Collectibles', value: 'toys_art_and_collectibles' },
  { label: 'Transportation Services', value: 'transportation_services' },
  { label: 'Travel Accessories & Luggage', value: 'travel_accessories_and_luggage' },
  { label: 'Accounting & Tax Services', value: 'accounting_and_tax_services' },
  { label: 'Healthcare Providers', value: 'healthcare_providers' },
  { label: 'Emerging Technology', value: 'emerging_technology' },
  { label: 'Other', value: 'other' }
]